import React from 'react';

import ReactDOM from 'react-dom';

import App from './App';
import './css/main.css';
import './css/react-table.css';
import './css/table-editor.css';
import './css/colorpicker.css';
import './css/polls.css';

ReactDOM.render(
    React.createElement(App),
    document.getElementById('root'),
);
